// src/ctxReflector/components/Instances/views/HighAvailability/request/request.ts
import axios, { AxiosResponse } from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

export function fetchClusters(token: string): Promise<AxiosResponse> {
    return axios.get(`${API_V1_URL}/ClusterCtxr/-1/list?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function deleteCluster(
    token: string,
    clusterId: number
): Promise<AxiosResponse> {
    return axios.delete(`${API_V1_URL}/ClusterCtxr/-1/${clusterId}?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function fetchSubscriptions(token: string): Promise<AxiosResponse> {
    return axios.get(`${API_V1_URL}/suscription?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function fetchDevices(
    token: string,
    subscriptionId: number
): Promise<AxiosResponse> {
    return axios.get(
        `${API_V1_URL}/ctxr/${subscriptionId}/listSelectorWithoutCluster?tenantId=1`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}

export function fetchInterfaces(
    token: string,
    deviceId: string
): Promise<AxiosResponse> {
    return axios.get(`${API_V1_URL}/ctxr/listcni/${deviceId}?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function createCluster(
    token: string,
    payload: unknown
): Promise<AxiosResponse> {
    return axios.post(`${API_V1_URL}/ClusterCtxr/create?tenantId=1`, payload, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function fetchOneCluster(
    token: string,
    clusterId: number
): Promise<AxiosResponse> {
    return axios.get(`${API_V1_URL}/ClusterCtxr/-1/${clusterId}?tenantId=1`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function updateCluster(
    token: string,
    clusterId: number,
    payload: unknown
): Promise<AxiosResponse> {
    return axios.put(`${API_V1_URL}/ClusterCtxr/-1/${clusterId}?tenantId=1`, payload, {
        headers: { Authorization: `Bearer ${token}` },
    });
}
